var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelgium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0756 0.862305H5.27559C2.62462 0.862305 0.475586 3.01134 0.475586 5.6623V32.0623C0.475586 34.7133 2.62462 36.8623 5.27559 36.8623H46.0756C48.7266 36.8623 50.8756 34.7133 50.8756 32.0623V5.6623C50.8756 3.01134 48.7266 0.862305 46.0756 0.862305Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.475586 0.862305H17.2756V36.8623H0.475586V0.862305Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0771 0.862305H50.8771V36.8623H34.0771V0.862305Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88185"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.475586,
    y: 0.862305,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelgium);
export default __webpack_public_path__ + "static/media/Belgium.ce1055937268f96c93ba96f6653cedd9.svg";
export { ForwardRef as ReactComponent };